import { ItemIDs } from '../../Config/Items';
import { IStateLevel } from '../../State/reducers/level';
import { IStateBoosters } from '../../State/reducers/boosters';
import { IStateScore } from '../../State/reducers/score';

export class LevelUtils {
    public static checkHasHint(
        level: IStateLevel,
        pre: IStateLevel,
        boosters: IStateBoosters,
        hints: number
    ) {
        if (level.hints.length !== pre.hints.length || level.hints.length !== hints) {
            if (
                boosters.currentBoosters.includes(ItemIDs.HINT) &&
                Math.floor(level.hints.length / 2) > hints
            ) {
                return true;
            }
        }

        return false;
    }

    public static getStarsWon(stateScore: IStateScore, score: number): number {
        let starsWon = stateScore.tiers.filter(tier => tier <= score).length;
        if (starsWon < 1) {
            starsWon = 1;
        }
        return starsWon;
    }
}
